import FormSelect from 'common/components/form/FormSelect';
import { Ref, useImperativeHandle, useMemo, useState } from 'react';
import { styled } from 'styled-components';
import Config from 'Config';
import { FilterItem } from './DocumentRequirementsPhotoSearchAndFilter';
import { generateRandomUUID } from '../../../utils/Utils';
import RadioGroup from '../../form/RadioGroup';

interface DocumentRequirementsPhotoFilterMediaTypeProps {
    ref?: Ref<{ clearSelectedMediaType: () => void }>;
    disabled: boolean;
    isShowDocumentFilter: boolean;
    onSelectedMediaTypeChanged: (mediaType: FilterItem) => void;
    className?: string;
}

const DocumentRequirementsPhotoFilterMediaType = ({
    onSelectedMediaTypeChanged,
    ref,
    disabled = false,
    isShowDocumentFilter = false,
    className,
}: DocumentRequirementsPhotoFilterMediaTypeProps) => {
    const [selectedValue, setSelectedValue] = useState<
        FilterItem | undefined
    >();
    const [key, setKey] = useState(generateRandomUUID());

    const clearSelectedMediaType = () => {
        setSelectedValue(undefined);
    };

    const handleOnChange = (item: FilterItem) => {
        onSelectedMediaTypeChanged(item);
        setSelectedValue(item);
        setKey(generateRandomUUID());
    };

    useImperativeHandle(ref, () => ({
        clearSelectedMediaType,
    }));

    const mediaTypeOptions: FilterItem[] = useMemo(
        () => [
            {
                name: 'All',
                value: 'ALL',
            },
            ...(isShowDocumentFilter
                ? [
                      {
                          name: 'Documents',
                          value: 'DOCUMENTS',
                      },
                  ]
                : []),
            {
                name: 'Photos',
                value: 'PHOTOS',
            },
            {
                name: 'Videos',
                value: 'VIDEOS',
            },
        ],
        [isShowDocumentFilter]
    );
    return (
        <StyledFormSelect
            key={key}
            options={mediaTypeOptions}
            placeholder='Media Type'
            onChange={handleOnChange}
            disabled={disabled}
            className={className}
            optionRenderer={props =>
                optionRadioRenderer({ ...props, selectedValue })
            }
            searchable={false}
        />
    );
};
export default DocumentRequirementsPhotoFilterMediaType;

export const optionRadioRenderer = props => {
    return (
        <StyledOptionContainer {...props.innerProps}>
            <StyledRadio
                name={props.data.value}
                options={[{ id: props.data.value, display: props.data.name }]}
                value={props.selectedValue?.value}
            />
        </StyledOptionContainer>
    );
};

const StyledOptionContainer = styled.div`
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
`;

const StyledRadio = styled(RadioGroup)`
    div.wrapper {
        & > div {
            font-size: 14px;
            font-weight: 600;
            & > div {
                border-color: ${Config.color.inputBorderGray};
            }
        }
    }
`;
const StyledFormSelect = styled(FormSelect)`
    min-width: 130px;

    .select-wrapper__placeholder {
        color: ${Config.color.darkNavy};
        font-size: 14px;
        font-weight: 600;
    }

    .select-wrapper__control--menu-is-open {
        background-color: ${Config.color.darkNavy};
        & .select-wrapper__placeholder,
        .fa-caret-up {
            color: ${Config.color.white};
        }
    }

    .select-wrapper__control--is-focused {
        border-color: ${Config.color.inputBorderGray} !important;
    }

    .select-wrapper--is-disabled {
        .select-wrapper__placeholder {
            color: #65768f;
        }
    }
`;
